import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import IconCog from 'cccisd-icons/cog2';
import IconReturnArrow from 'cccisd-icons/enter4';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Fortress = window.cccisd.fortress;

const icons = {
    cog: IconCog,
};

const NavBar = ({ className, noLogoLink, noSecondaryNav }) => {
    let primaryNavLinks = [];
    let secondaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'primaryNav').nav;
        secondaryNavLinks = Appdefs.navs
            .find(n => n.handle === 'secondaryNav')
            .nav.map(n => ({ ...n, icon: n.icon ? icons[n.icon] : null }));
    } catch (e) {
        // meh, leave it empty
    }

    if (noSecondaryNav) {
        secondaryNavLinks = [];
    }

    return (
        <Header
            containerClassName={className}
            logoClassName={style.logoPlaceholder}
            primaryNavLinks={primaryNavLinks}
            secondaryNavLinks={secondaryNavLinks}
            showAlertAction={false}
            showHomeAction={false}
            showAdminAction={Fortress.isSuperUser()}
            {...(noLogoLink ? { logoLink: null } : {})}
            additionalIconLinks={[
                {
                    icon: () => (
                        <span className={style.returnToShift}>
                            <IconReturnArrow spaceRight />
                            Return to SHIFT Wellness
                        </span>
                    ),
                    handle: 'back',
                    url: 'https://www.shiftwellness.org',
                },
            ]}
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
    noLogoLink: false,
    noSecondaryNav: false,
};

NavBar.propTypes = {
    className: PropTypes.string,
    noLogoLink: PropTypes.bool,
    noSecondaryNav: PropTypes.bool,
};

export default NavBar;
